import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { TFunction } from 'react-i18next';
import { OtpConfirmModalProps } from './OtpConfirmation.modal.web';

export enum OtpConfirmationStackRoutes {
  OtpConfirmation = 'OtpConfirmation'
}

export type OtpConfirmationStackParamList = {
  [OtpConfirmationStackRoutes.OtpConfirmation]: OtpConfirmModalProps;
};

export type OtpConfirmationStackScreenProps<Screen extends keyof OtpConfirmationStackParamList> = NativeStackScreenProps<
  OtpConfirmationStackParamList,
  Screen
>;

export const errorParser = (errorText: string, t: TFunction<'global-bill-payment', undefined>) => {
  switch (errorText) {
    case 'MIGRATION_NOT_AVAILABLE':
      return t('global-bill-payment::otp.error--migration-not-available');
    case 'OTP_INVALID':
      return t('global-bill-payment::otp.error--otp-invalid');
    case 'FAILED_TO_GET_OTP':
      return t('global-bill-payment::otp.error--fail-to-get-otp');
    case 'ERR_LOGIN_FAILED':
      return t('global-bill-payment::otp.error--too-many-attempts');
    case 'INVALID_CREDENTIALS':
      return t('global-bill-payment::otp.error--invalid-credentials');
    case 'ACCOUNT_LOCKED':
      return t('global-bill-payment::otp.error--account-locked');
    case 'ACCOUNT_NOT_FOUND':
      return t('global-bill-payment::otp.error--account-not-found');
    case 'FAILED_TO_SEND_OTP':
      return t('global-bill-payment::otp.error--fail-to-send');
    case 'ACCOUNT_WITH_EMAIL_ALREADY_EXISTS':
      return t('global-bill-payment::otp.error--email-exists');
    case 'Network Error':
      return t('global-bill-payment::otp.INTERNAL_SERVER_ERROR');
    default:
      return errorText;
  }
};
